module.exports = __webpack_public_path__ + "img/ugsticker.bcad4edd.svg";